import { mdiCheckDecagramOutline, mdiCloseOctagonOutline } from "@mdi/js";
import Icon from "@mdi/react";
import clsx from "clsx";

import { DataCheckSVGIcon } from "components/SVGIcons";
import styles from "./style.module.scss";

interface IProps {
  credit?: string;
  credit_approved: string;
}

const getStatusClass = (credit_approved: string) => {
  switch (credit_approved) {
    case "approved":
      return "text-approvedBorder border border-approvedBorder";

    case "pending":
      return "text-pendingBorder border border-pendingBorder";

    case "declined":
      return "text-declinedBorder border border-declinedBorder";

    default:
      return "text-pendingBorder border border-pendingBorder";
  }
};

export default function CreditStatus({ credit = "", credit_approved }: Readonly<IProps>) {
  return (
    <div className={clsx(styles.statusButton, getStatusClass(credit_approved))}>
      {credit_approved === "declined" ? (
        <Icon path={mdiCloseOctagonOutline} className="flex-none size-5" />
      ) : (
        <>
          {credit_approved === "approved" ? (
            <Icon path={mdiCheckDecagramOutline} className="flex-none size-5" />
          ) : (
            <DataCheckSVGIcon className="flex-none size-5" />
          )}
        </>
      )}
      <span className="capitalize">{credit}</span>
    </div>
  );
}
